// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const statusInNoteOneMax = 4000;

export const StatusIn = zod.object({
  "note": zod.union([zod.string().max(statusInNoteOneMax),zod.null()]).optional(),
  "status": zod.enum(['new', 'in_review', 'planned', 'in_progress', 'resolved', 'declined'])
});

export type StatusIn = zod.input<typeof StatusIn>;
export type StatusInOutput = zod.output<typeof StatusIn>;
